import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Buttons from 'theme/components/Buttons.style';
import * as Dialog from 'auth/styles/SharedDeviceLockoutDialog.style';

export type SharedDeviceDialogStep =
  | 'closed'
  | 'ask_shared'
  | 'switch_accounts';

interface Props {
  step: SharedDeviceDialogStep;
  onAnswerShared: () => void;
  onAnswerNotShared: () => void;
  onSwitchAccounts: () => void;
  onClose: () => void;
}

const SharedDeviceLockoutDialog = ({
  step,
  onAnswerShared,
  onAnswerNotShared,
  onSwitchAccounts,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation('pageLogin');

  const isOpen = step !== 'closed';
  const isSwitchStep = step === 'switch_accounts';

  return (
    <Dialog.Container
      open={isOpen}
      onClose={onClose}
      PaperComponent={Dialog.Card}
      aria-labelledby="shared-device-dialog-title"
      aria-describedby="shared-device-dialog-description"
    >
      <Dialog.Header>
        <Dialog.Title id="shared-device-dialog-title">
          {isSwitchStep
            ? t('sharedDevice.switchAccounts.title')
            : t('sharedDevice.ask.title')}
        </Dialog.Title>
        <Dialog.Body id="shared-device-dialog-description">
          {isSwitchStep
            ? t('sharedDevice.switchAccounts.body')
            : t('sharedDevice.ask.body')}
        </Dialog.Body>
      </Dialog.Header>
      <Dialog.Actions>
        {isSwitchStep ? (
          <>
            <Buttons.SecondaryLight onClick={onClose} medium>
              {t('sharedDevice.switchAccounts.stayButton')}
            </Buttons.SecondaryLight>
            <Buttons.SecondaryDark onClick={onSwitchAccounts} medium>
              {t('sharedDevice.switchAccounts.logoutButton')}
            </Buttons.SecondaryDark>
          </>
        ) : (
          <>
            <Buttons.SecondaryLight onClick={onAnswerNotShared} medium>
              {t('sharedDevice.ask.noButton')}
            </Buttons.SecondaryLight>
            <Buttons.SecondaryDark onClick={onAnswerShared} medium>
              {t('sharedDevice.ask.yesButton')}
            </Buttons.SecondaryDark>
          </>
        )}
      </Dialog.Actions>
    </Dialog.Container>
  );
};

export default SharedDeviceLockoutDialog;
